import { aMapKey } from '../components/config-v2';

export const libsMap: { [key: string]: any } = {
  // echarts: `${process.env.STATIC_RES_DOMAIN}/libs/echarts/5.1.2/echarts-flow.min.js`,
  YDPlayer: `${process.env.STATIC_RES_DOMAIN}/libs/ydplayer/20220728/ydplayer-compatible.js`,
  jPlayer: '/player.js',
  subway: `//webapi.amap.com/subway?v=1.0&key=${aMapKey}&callback=cbk`,
  hls: `${process.env.STATIC_RES_DOMAIN}/libs/hls/1.6.7/hls.min.js`
};
